module.exports = __webpack_public_path__ + "static/media/woocommerce-style.9b46673c.png";